<div
  class="social-wall-card"
  data-cy="social-wall-open-post"
  (click)="open.emit()">
  <div class="social-wall-card__media">
    @if (media(); as media) {
      @switch (media.type) {
        @case ('image') {
          <img [cropImage]="media.value | preSignedUrl | async" alt="Social wall image">
        }
        @case ('video') {
          <lib-video
            class="social-wall-card__media-video"
            [src]="(media.value | videoPresign | async) ?? ''"
            [containerHeight]="320"
            (click)="$event.stopPropagation()">
          </lib-video>
        }
        @case ('audio') {
          <lib-audio-waveform-player
            class="social-wall-card__media-audio"
            [src]="(media.value | preSignedUrl : entityTypeId.MEDIA : bundleType.AUDIO : fieldName.AWS_FILE | async) ?? ''"
            (click)="$event.stopPropagation()">
          </lib-audio-waveform-player>
        }
      }
    }
  </div>
  <div class="social-wall-card__body">
    <div class="social-wall-card__user">
      <lib-user-avatar [size]="32" [user]="item().user"></lib-user-avatar>
      <div class="social-wall-card__user-details">
        <div class="social-wall-card__user-name">{{ item().user?.formattedProfileName }}</div>
        <div class="social-wall-card__user-time">{{ item().created | timeElapsed }}</div>
      </div>
    </div>
    <div class="social-wall-card__content" [innerHtml]="item().text"></div>
    <div class="social-wall-card__footer">
      <div class="social-wall-card__action-list">
        <div class="social-wall-card__action">
          <lib-icon icon="heart"></lib-icon>
          {{ item().totalLikes || 0 }}
        </div>
        <div class="social-wall-card__action">
          <lib-icon icon="chat-teardrop-text"></lib-icon>
          {{ item().totalReplies || item().replies?.length || 0 }}
        </div>
      </div>
      <div class="social-wall-card__pin">
        <button
          mat-button
          class="button button--icon"
          data-cy="social-wall-pin"
          (click)="$event.stopPropagation()">
          <lib-icon icon="push-pin" [fill]="false"></lib-icon>
        </button>
      </div>
    </div>
  </div>
</div>
